import { ColDef, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AgGridCustomTable from "../../../../../../../util/component/AgGridCustomTable";
import { useBookingByIdWithMetaQueryObserver } from "../../../../../api/services";
import { BookingChangelogTableRow } from "../../../types";
import { setDecimalSeparator } from "../../../../../utils";
import CustomLoader from "../../../../../../../util/component/CustomLoader";
import { RouteParams } from "../../../../../types";

const TabChangelog = () => {

    const { t, i18n } = useTranslation('booking');

    const { id } = useParams<RouteParams>();

    const bookingQuery = useBookingByIdWithMetaQueryObserver(id);

    const columnDefs = useMemo<ColDef<BookingChangelogTableRow>[]>(() => [
        {
            field: "datetime",
            headerName: t("label.timestamp"),
            sortable: true,
            sort: 'desc',
            valueFormatter: (params: ValueFormatterParams<BookingChangelogTableRow, string>) => dayjs(params.value).format('DD-MM-YYYY HH:mm')
        },
        {
            field: "operator",
            headerName: t("label.editor"),
            valueGetter: (params: ValueGetterParams<BookingChangelogTableRow>) => params.data?.operator?.username ?? '-'
        },
        {
            field: "fieldName",
            headerName: t("label.fieldName"),
            valueFormatter: (params: ValueFormatterParams<BookingChangelogTableRow, string>) => {
                const splitted = !!params?.value ? params.value.split(".") : [];
                return splitted.map((elem: string) => !!t(`label.${elem}`) ? t(`label.${elem}`) : elem).join(' - ')
            }
        },
        {
            field: "originalValue",
            headerName: t("label.originalValue"),
            valueFormatter: (params: ValueFormatterParams<BookingChangelogTableRow, string>) => {
                switch (params?.data?.fieldName) {
                    case 'totalToBePaid':
                        return setDecimalSeparator(((parseInt(params.value) ?? 0) / 100).toFixed(2), i18n.language);
                    case 'pickupDatetime':
                    case 'dropoffDatetime':
                    case 'dropoffReplacementDatetime':
                        return !!params.value ? dayjs(params.value).format('DD-MM-YYYY HH:mm') : '';
                    case 'discountOverprice':
                        return !!params.value ? `${params.value} %` : `0 %`;
                    default:
                        if(params?.data?.fieldName.includes('birthDate')) {
                            return !!params.value ? dayjs(params.value).format('DD-MM-YYYY') : '';
                        }
                            return params.value;
                }
            }
        },
        {
            field: "newValue",
            headerName: t("label.newValue"),
            valueFormatter: (params: ValueFormatterParams<BookingChangelogTableRow, string>) => {
                switch (params?.data?.fieldName) {
                    case 'totalToBePaid':
                        return setDecimalSeparator(((parseInt(params.value) ?? 0) / 100).toFixed(2), i18n.language);
                    case 'pickupDatetime':
                    case 'dropoffDatetime':
                    case 'dropoffReplacementDatetime':
                        return !!params.value ? dayjs(params.value).format('DD-MM-YYYY HH:mm') : '';
                    case 'discountOverprice':
                        return !!params.value ? `${params.value} %` : `0 %`;
                    default:
                        if(params?.data?.fieldName.includes('birthDate')) {
                            return !!params.value ? dayjs(params.value).format('DD-MM-YYYY') : '';
                        }
                        return params.value;
                }
            }
        }
    ], [t]);
    const defaultColDef = useMemo<ColDef>(() => ({
        resizable: true,
        unSortIcon: true
    }), []);
    const rowData = useMemo<BookingChangelogTableRow[]>(() => (
        bookingQuery.data?.booking.changelog ?? []
    ), [bookingQuery.data]);

    return (
        <>
            <AgGridCustomTable<BookingChangelogTableRow>
                height="500px"
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowData={rowData}
                pagination={false}
            />
            <CustomLoader loading={bookingQuery.isLoading} />
        </>
    )
};

export default TabChangelog;
